const Calendar = ({ width = 14, height = 17 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 14 17"
    fill="none"
  >
    <g clipPath="url(#clip0_829_17787)">
      <path
        d="M3.5 0.5C3.775 0.5 4 0.723875 4 1V2.5H10V1C10 0.723875 10.225 0.5 10.5 0.5C10.775 0.5 11 0.723875 11 1V2.5H12C13.1031 2.5 14 3.39531 14 4.5V14.5C14 15.6031 13.1031 16.5 12 16.5H2C0.895313 16.5 0 15.6031 0 14.5V4.5C0 3.39531 0.895313 2.5 2 2.5H3V1C3 0.723875 3.225 0.5 3.5 0.5ZM13 6.5H1V14.5C1 15.0531 1.44781 15.5 2 15.5H12C12.5531 15.5 13 15.0531 13 14.5V6.5ZM12 3.5H2C1.44781 3.5 1 3.94687 1 4.5V5.5H13V4.5C13 3.94687 12.5531 3.5 12 3.5Z"
        fill="#111928"
      />
    </g>
    <defs>
      <clipPath id="clip0_829_17787">
        <rect width="14" height="16" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default Calendar;
